import { ROUTES } from '@/constants/routes/default';
import { getFullYear } from '@/helpers/date';
import Image from 'next/image';
import Link from 'next/link';

const FooterKG = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex flex-col max-md:px-4  md:px-10 max-md:py-6 md:py-10 border-t border-kg-athens-gray bg-white">
      <div className="max-w-295 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4 max-md:flex-col max-md:items-start max-md:gap-5">
        <div>
          <Link href={ROUTES.home} aria-label="Kimble Group home">
            <Image
              width="144"
              height="12"
              src="https://assets.kimblegroup.com/kimblegroup/2024-04/logo_v2.png"
              alt="Kimble Group"
              unoptimized
              priority
            />
          </Link>
          <p className="mt-3 text-kg-mako text-xs md:max-w-60">
            An AI recruiter that reads every listing so you don&apos;t have to
          </p>
        </div>
        <nav
          aria-label="Footer"
          className="w-fit flex flex-wrap gap-y-3 gap-x-12 text-kg-mako text-sm"
        >
          <ul className="flex flex-col gap-3">
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.jobs}>
                Search all jobs
              </Link>
            </li>
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.partners}>
                Partnerships
              </Link>
            </li>
            <li>
              {isAuthorized ? (
                <Link className="block w-fit hover:underline" href={ROUTES.profile}>
                  Career profile
                </Link>
              ) : (
                <Link className="block w-fit hover:underline" href={ROUTES.signup}>
                  Create profile
                </Link>
              )}
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.termsOfUse}>
                Terms of Use
              </Link>
            </li>
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.privacyPolicy}>
                Privacy Policy
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="flex justify-between items-center gap-2 flex-wrap m-auto max-w-295 w-full border-dashed border-t border-kg-athens-gray pt-5 mt-5">
        <p className="text-kg-mako text-xs">Houston · New York · Los Angeles · Seattle · Atlanta</p>
        <p className="text-kg-mako text-xs">
          2450 Louisiana St. Suite 400-437, Houston, TX 77006 · Copyright © Kimble Group,{' '}
          {getFullYear()}
        </p>
      </div>
    </footer>
  );
};

export default FooterKG;
